/* ancona-upgrade-2026-08-15.js — contract docs in working/ git history (closure 2026-08-17, byte budget). */
(function () {
'use strict';
if (window.__anconaUpgrade20260815) return;
window.__anconaUpgrade20260815 = true;
var root = document.documentElement;
if (root && !root.hasAttribute('data-ancona-upgrade-2026-08-15')) {
root.setAttribute('data-ancona-upgrade-2026-08-15', 'on');
}
function initRemovalAnnouncer() {
try {
if (document.body.dataset.anconaRemovalAnnouncer === '1') return;
var strings = window.anconaA11yStrings;
var region = document.getElementById('ancona-live-region');
if (!strings || typeof strings.itemRemoved !== 'string' || !region) return;
if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS || !PUB_SUB_EVENTS.cartUpdate) return;
document.body.dataset.anconaRemovalAnnouncer = '1';
var pending = null;
function lineCount() {
try { return document.querySelectorAll('.cart-item').length; } catch (e) { return -1; }
}
function announceIfRemoved() {
if (!pending) return;
if (Date.now() - pending.at > 8000) { pending = null; return; }
if (pending.baseline >= 0 && lineCount() >= pending.baseline) return;
var text = strings.itemRemoved.replace('[[TITLE]]', pending.title);
pending = null;
region.textContent = '';
window.requestAnimationFrame(function () { region.textContent = text; });
}
document.addEventListener('click', function (e) {
try {
var t = e.target;
if (!t || !t.closest) return;
var rb = t.closest('cart-remove-button');
if (!rb) return;
var item = rb.closest('.cart-item');
var nameEl = item && item.querySelector('.cart-item__name');
pending = {
title: nameEl ? nameEl.textContent.replace(/\s+/g, ' ').trim() : '',
at: Date.now(),
baseline: lineCount()
};
setTimeout(function () { try { announceIfRemoved(); } catch (err) {  } }, 1600);
setTimeout(function () { try { announceIfRemoved(); } catch (err) {  } }, 3200);
} catch (err) {  }
}, true);
subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
try { announceIfRemoved(); } catch (err) { pending = null; }
});
} catch (e) {  }
}
function initMegaMenuKeys() {
try {
var nav = document.querySelector('.header__inline-menu');
if (!nav || nav.dataset.anconaMegaKeysBound) return;
nav.dataset.anconaMegaKeysBound = '1';
var itemSel = 'summary.header__menu-item, a.header__menu-item';
nav.addEventListener('keydown', function (e) {
var items = Array.prototype.slice.call(nav.querySelectorAll(itemSel));
if (!items.length) return;
var idx = items.indexOf(document.activeElement);
if (e.key === 'ArrowRight' && idx !== -1) {
e.preventDefault();
items[(idx + 1) % items.length].focus();
} else if (e.key === 'ArrowLeft' && idx !== -1) {
e.preventDefault();
items[(idx - 1 + items.length) % items.length].focus();
} else if (e.key === 'Escape') {
var open = nav.querySelector('details[open]');
if (open) {
e.preventDefault();
open.removeAttribute('open');
var sum = open.querySelector('summary');
if (sum) sum.focus();
}
} else if (e.key === 'ArrowDown' && idx !== -1) {
var det = items[idx].closest('details');
if (det) {
if (!det.hasAttribute('open')) det.setAttribute('open', '');
var first = det.querySelector('.mega-menu__content a');
if (first) {
e.preventDefault();
first.focus();
}
}
}
});
} catch (e) {  }
}
function initHeaderHeightVar() {
try {
var update = function () {
try {
var h = document.querySelector('.section-header');
if (h && h.offsetHeight) {
root.style.setProperty('--header-height', h.offsetHeight + 'px');
}
} catch (e) {  }
};
if (!root.hasAttribute('data-ancona-header-h-bound')) {
root.setAttribute('data-ancona-header-h-bound', '');
var t;
window.addEventListener('resize', function () {
clearTimeout(t);
t = setTimeout(update, 100);
}, { passive: true });
window.addEventListener('orientationchange', update, { passive: true });
if (window.visualViewport) {
window.visualViewport.addEventListener('resize', update, { passive: true });
}
if (document.fonts && document.fonts.ready) {
document.fonts.ready.then(update).catch(function () {  });
}
}
var el = document.querySelector('.section-header');
if (el && !el.hasAttribute('data-ancona-header-h-observed')) {
el.setAttribute('data-ancona-header-h-observed', '');
if ('ResizeObserver' in window) {
try {
if (window.__anconaHeaderRO) { window.__anconaHeaderRO.disconnect(); }
window.__anconaHeaderRO = new ResizeObserver(update);
window.__anconaHeaderRO.observe(el);
} catch (e) {  }
}
update();
}
} catch (e) {  }
}
function initCheckoutGuard() {
try {
if (window.__anconaCheckoutGuard) return;
window.__anconaCheckoutGuard = true;
function arm(form) {
if (!form || form.__anconaGuarded) return;
form.__anconaGuarded = true;
form.setAttribute('data-ancona-wired', 'checkout-guard');
form.addEventListener('submit', function (e) {
if (e.submitter && e.submitter.name !== 'checkout') return;
var btn = (e.submitter && e.submitter.name === 'checkout')
? e.submitter
: ((form.id && document.querySelector('button[name="checkout"][form="' + form.id + '"]'))
|| form.querySelector('button[name="checkout"]'));
if (!btn) return; // not a checkout submission
if (form.dataset.anconaSubmitting) {
e.preventDefault();
e.stopPropagation();
return;
}
form.dataset.anconaSubmitting = '1';
setTimeout(function () {
if (e.defaultPrevented) {
delete form.dataset.anconaSubmitting;
return;
}
btn.disabled = true;
btn.setAttribute('aria-busy', 'true');
btn.dataset.anconaSubmitting = '1';
setTimeout(function () {
if (btn.dataset.anconaSubmitting === '1') {
btn.disabled = false;
btn.removeAttribute('aria-busy');
delete btn.dataset.anconaSubmitting;
delete form.dataset.anconaSubmitting;
}
}, 8000);
}, 0);
}, true);
}
function scan() {
['CartDrawer-Form', 'cart'].forEach(function (id) {
arm(document.getElementById(id));
});
}
scan();
document.addEventListener('cart:refresh', scan);
document.addEventListener('shopify:section:load', scan);
if (typeof subscribe === 'function'
&& typeof PUB_SUB_EVENTS !== 'undefined'
&& PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
try { scan(); } catch (e) {  }
});
}
window.addEventListener('pageshow', function (e) {
if (!e.persisted) return;
var nodes = document.querySelectorAll('button[name="checkout"]');
for (var i = 0; i < nodes.length; i++) {
nodes[i].disabled = false;
nodes[i].removeAttribute('aria-busy');
delete nodes[i].dataset.anconaSubmitting;
}
var forms = document.querySelectorAll('form[data-ancona-wired="checkout-guard"]');
for (var j = 0; j < forms.length; j++) {
delete forms[j].dataset.anconaSubmitting;
}
});
} catch (e) {  }
}
function initPredictiveEscape() {
try {
if (window.__anconaPredictiveEscape) return;
window.__anconaPredictiveEscape = true;
document.addEventListener('keyup', function (e) {
if (e.key !== 'Escape') return;
var t = e.target;
if (!t || !t.closest) return;
var ps = t.closest('predictive-search');
if (!ps || !ps.hasAttribute('open')) return;
e.stopPropagation();
try {
if (typeof ps.close === 'function') {
ps.close();
} else {
ps.removeAttribute('open');
}
var input = ps.querySelector('input[type="search"]');
if (input) input.focus();
} catch (err) {  }
}, true);
} catch (e) {  }
}
function runAll() {
initMegaMenuKeys();
initHeaderHeightVar();
initCheckoutGuard();
initPredictiveEscape();
initRemovalAnnouncer();
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', runAll, { once: true });
} else {
runAll();
}
document.addEventListener('shopify:section:load', function () {
initMegaMenuKeys();
initHeaderHeightVar();
initCheckoutGuard();
});
})();
